<nav class="navbar navbar-expand-lg navbar-dark fixed-top bg-dark">
  <div class="container-fluid">
    <a class="navbar-brand" routerLink="/"><img src="design/images/logo.png" /></a>
    <p class="navbar-brand">Transitions Management Tool</p>

    <button *ngIf="showUser" class="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarCollapse"
            aria-controls="navbarCollapse" aria-expanded="false" aria-label="Toggle navigation">
      <span class="navbar-toggler-icon"></span>
    </button>
    <div class="collapse navbar-collapse" id="navbarCollapse">
      <ul class="navbar-nav mr-auto">
        <li class="nav-item">
          <a class="nav-link" routerLinkActive="active" routerLink="/home">Home</a>
        </li>
        <li class="nav-item">
        <div class="dropdown">
         
          <a class="nav-link"[class.active]="isActiveDropdown" *ngIf="showMenu('m-rmt') || showMenu('m-cw')" >Recruitment</a>
          <div class="dropdown-content">
            <a class="nav-link" routerLink="/recruitment" routerLinkActive="active" [eosHasAccess]="'RMT'"  *ngIf="showMenu('m-rmt')" >Recruitment</a>
            <a class="nav-link" routerLinkActive="active" routerLink="/subcontractor" [eosHasAccess]="'CW'" *ngIf="showMenu('m-cw')">Sub Contractor</a>
           
          </div>
        </div>
      </li>
       
        <li class="nav-item" *ngIf="showMenu('m-ptc')" [eosHasAccess]="'PTC'">
          <a class="nav-link" routerLinkActive="active"  routerLink="/pre-boarding">Pre-joining</a>
        </li>
        <li class="nav-item" *ngIf="showMenu('m-imm')" [eosHasAccess]="'IMM'">
          <a class="nav-link" routerLinkActive="active" routerLink="/immigration">Immigration</a>
        </li>
        <li class="nav-item" *ngIf="showMenu('m-ext')" [eosHasAccess]="'EXT'">
          <a class="nav-link" routerLinkActive="active" routerLink="/exit">Exit</a>
        </li>
       
      </ul>
    </div>
    <div style="margin-right:15px;cursor:pointer;position:relative">
      <img src="design/images/help-2.png" title="Get technical Support" style="width:34px;" (click)="serviceNow()" placement="bottom" />          
    </div>
    <div *ngIf="isExit && user.roles.indexOf('ExitTeam')!=-1" style="margin-right:30px;cursor:pointer;position:relative">
      <img src="design/images/bell.png" [ngClass]="{'is-delagated':isDelgated}" (click)="ShowNotification()"
           placement="bottom" />
      <span class="count" *ngIf="isExit && !this.signalRService.data">{{this.notificationCount}}</span>
      <span class="count" *ngIf="isExit && this.signalRService.data">{{this.signalRService.data}}</span>
    </div>
    <div *ngIf="isImmigration" style="margin-right:15px;cursor:pointer;position:relative">
      <img src="design/images/user-manual.png" title="User manual" style="width:27px;" (click)="help()" placement="bottom" />          
    </div>
    <div class="user" *ngIf="showUser">
      <img src="design/images/user-1.png" [ngClass]="{'is-delagated':isDelgated}" placement="bottom"
           ngbTooltip="Actions are currently being delegated. Go to settings to undo delegation"
           [disableTooltip]="!isDelgated" [closeDelay]="1500" tooltipClass="delegate-tooltip" routerLink="/user" />
      <div
        [autoClose]="isDropdownClose"
        class="dropdown"
        ngbDropdown
        #dropdown="ngbDropdown"
        display="dynamic"
        placement="bottom-right">
        <p class="dropdown-toggle" data-bs-toggle="dropdown" ngbDropdownToggle>
          {{loggedInUserDisplayName}}
        </p>
        <div class="dropdown-menu" ngbDropdownMenu>
          <a class="dropdown-item" (click)="closeDropdown()" routerLink="/user" ngbDropdownItem>Profile</a>
          <a class="dropdown-item" (click)="closeDropdown()" *ngIf="isAdmin" routerLink="/admin" ngbDropdownItem>Admin</a>          
          <a class="dropdown-item" (click)="closeDropdown()" routerLink="/settings" ngbDropdownItem>Settings</a>
         <a *ngIf="isAmendTask || isTemplateEditor || isConfigDropdownPJC"
            class="dropdown-item"
            (click)="selectOption('Prejoining', $event)"
            ngbDropdown
          >
            <p
              class="dropdown-arrow d-flex justify-content-between align-items-center"
            >
              Pre-joining
              <i
                [ngClass]="{
                  'arrow-right': expandedItem !== 'Prejoining',
                  'arrow-down': expandedItem === 'Prejoining'
                }"
              ></i>
            </p>
          </a>
          <div *ngIf="expandedItem === 'Prejoining'" style="padding-left: 20px">
            <a
              class="dropdown-item"
              *ngIf="isAmendTask"
              (click)="closeDropdown()"
              routerLink="/configure-activities"
              ngbDropdownItem
            >
              Configure activities
            </a>
            <a
              class="dropdown-item"
              *ngIf="isTemplateEditor"
              (click)="closeDropdown()"
              routerLink="/configure-template"
              ngbDropdownItem
            >
              Configure template
            </a>
            <a class="dropdown-item" *ngIf="isConfigDropdownPJC" (click)="closeDropdown()" routerLink="/configure-lookuptype/PJC" ngbDropdownItem>
              Configure
              dropdown
            </a>  
          </div>
          <a  *ngIf="isImmActivityEditor || isImmTemplateEditor || isImmDocumentVisamapping || isConfigDropdownIMM"
            class="dropdown-item"
            (click)="selectOption('Immigration', $event)"
            ngbDropdown
          >
            <p
              class="dropdown-arrow d-flex justify-content-between align-items-center"
            >
              Immigration
              <i
                [ngClass]="{
                  'arrow-right': expandedItem !== 'Immigration',
                  'arrow-down': expandedItem === 'Immigration'
                }"
              ></i>
            </p>
          </a>
          <div
            *ngIf="expandedItem === 'Immigration'"
            style="padding-left: 20px"
          >
            <a
              class="dropdown-item"
              *ngIf="isImmActivityEditor"
              (click)="closeDropdown()"
              routerLink="/configure-immactivities"
              ngbDropdownItem
            >
              Configure activities
            </a>
            <a
              class="dropdown-item"
              *ngIf="isImmTemplateEditor"
              (click)="closeDropdown()"
              routerLink="/configure-Immtemplate"
              ngbDropdownItem
            >
              Configure template
            </a>
            <a
              class="dropdown-item"
              *ngIf="isImmDocumentVisamapping"
              (click)="closeDropdown()"
              routerLink="/configure-immdocumentvisamapping"
              ngbDropdownItem
            >
              Configure document
            </a>
            <a class="dropdown-item" *ngIf="isConfigDropdownIMM" (click)="closeDropdown()" routerLink="/configure-lookuptype/IMM" ngbDropdownItem>
              Configure
              dropdown
            </a>  
          </div>

          <a  *ngIf="isExitActivityEditor || isExitTemplateEditor || isConfigDropdownEXT"
            class="dropdown-item"
            (click)="selectOption('Exit', $event)"
            ngbDropdown
          >
            <p
              class="dropdown-arrow d-flex justify-content-between align-items-center"
            >
              Exit
              <i
                [ngClass]="{
                  'arrow-right': expandedItem !== 'Exit',
                  'arrow-down': expandedItem === 'Exit'
                }"
              ></i>
            </p>
          </a>
          <div *ngIf="expandedItem === 'Exit'" style="padding-left: 20px">
            <a
              class="dropdown-item"
              *ngIf="isExitActivityEditor"
              (click)="closeDropdown()"
              routerLink="/configure-exitactivities"
              ngbDropdownItem
            >
              Configure activities
            </a>
            <a
              class="dropdown-item"
              *ngIf="isExitTemplateEditor"
              (click)="closeDropdown()"
              routerLink="/configure-exit-template-editor"
              ngbDropdownItem
            >
              Configure template
            </a>
            <a class="dropdown-item" *ngIf="isConfigDropdownEXT" (click)="closeDropdown()" routerLink="/configure-lookuptype/EXT" ngbDropdownItem>
              Configure
              dropdown
            </a> 
          </div>
          <a class="dropdown-item" *ngIf="isAdmin" (click)="closeDropdown()" routerLink="/configure-lookuptype/TMT" ngbDropdownItem>
            Configure
            dropdown
          </a>          
          <a class="dropdown-item" [routerLink]="" (click)="logout()" ngbDropdownItem>Logout</a>
        </div>
      </div>
    </div>
  </div>
</nav>

<style>
  .count {
    vertical-align: top;
    background-color: white;
    color: black;
    width: 22px;
    height: 22px;
    display: block;
    border-radius: 50%;
    border-radius: 50% !important;
    text-align: center;
    vertical-align: middle;
    padding-top: -1px !important;
    margin-top: -35px;
    z-index: 500 !important;
    position: absolute;
    cursor:pointer;
    margin-left: 15px;
  }
  .dropdown-menu{
    z-index: 2000; 
}
.dropdown:hover .dropdown-content {display: block;}
.dropdown-content a {
  color: white;
  padding: 12px 16px;
  text-decoration: none;
  display: block;
}
.dropdown-content {
  display: none;
  position: absolute;
  background-color: #333;
  min-width: 160px;
  box-shadow: 0px 8px 16px 0px rgba(0,0,0,0.2);
  z-index: 1;
}
.dropdown-content a:hover {
  /* background-color: yellow; */
  color: yellow;

}
</style>
